export default "<a href=\"{{ url }}\" target=\"_blank\">View Pdf</a>\r\n"